<template>
  <div class="eDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <div class="writeContent">
      <h2>{{setNews.title}}</h2>
      <div class="read">
        <span>浏览量：{{setNews.read}}</span>
        <span>分享来源<font>{{setNews.soure}}</font></span>
      </div>

      <div class="card" @click="$router.push('indy')">
        <img :src="user.avatar == '' ? avatar : baseUrl+user.avatar" />
        <div>
          <span>{{user.username}}</span>
          <span>云端生活经纪人</span>
        </div>
        <i class="el-icon-arrow-right iconT"></i>
      </div>

      <div class="con">
      <div v-html="setNews.content"></div> 
      </div>

    </div>


 

    <div class="shareFooter">
      <div class="edit" @click="jump(setNews.id,'edit')">
        <span>取消</span>
      </div>
      <div class="shareTo">立即完成</div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        setNews:[],
        setPro:[],
        baseUrl:'',
        show:false,
        status:1,
        user:[],
        avatar:require( '../../assets/images/logo.png'),
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        this.open()
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.detail(); 
      $('body').on('click','.con img,.con p,.con li',function(){
        $(this).remove()
        console.log($('.con').html())
      })
    },

    methods: {
      detail:function(e){
        var id = this.$route.query.id;
        var that = this;
        this.axios({
          'url': that.$host+'wx/news/detail',
          'method': 'post',
          params:{
            id:id,
            userId:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setNews = res.rs;
          that.setPro =  res.pro;
          that.status =  res.status;
          that.user = res.result;
          document.title = res.rs.title;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      delPro:function(id,index){
        var that = this;
        if(that.status == 1){
          this.$delete(this.setPro,index)
          return false;
        }
        this.axios({
          'url': that.$host+'wx/news/del',
          'method': 'post',
          params:{
            id:id,
            userId:that.userData.id
          }
        }).then(function(response){
          that.$delete(that.setPro,index)
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
           id:index
         }
        })
      },
      open:function() {
        this.$alert('请先登录！', '警告', {
          confirmButtonText: '确定',
          showClose:false,
          callback: action => {
            var url = encodeURIComponent('http://user.laife.cn/main/login');
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf57bae009c299252&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
            return;
          }
        });
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .eDetailApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }
  .eDetailApp .writeContent{
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:65px
  }
  .eDetailApp .writeContent h2{
    font-size:18px;
    padding:15px 0 10px 0;
  }
  .eDetailApp .writeContent .read:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0;
  }
  .eDetailApp .writeContent .read span{
    float:left;
    font-size:14px;
    color:#7f8995
  }
  .eDetailApp .writeContent .read span:last-child{
    float:right;
    width:70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .eDetailApp .writeContent .read span font{
    color:#333;
    padding-left:5px;
    font-weight:bold;

  }
  .eDetailApp .writeContent .card{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding:10px 15px 5px 15px;
    margin-top:20px;
  }
  .eDetailApp .writeContent .card img{
    display:inline-block;
    width:60px;
    border-radius:6px;
  }
  .eDetailApp .writeContent .card div{
    display:inline-block;
    vertical-align:top;
    padding-left:10px;
  }
  .eDetailApp .writeContent .card div span{
    display:block;
    font-size:16px;
    font-weight:bold;
    padding-top:8px;
  }
  .eDetailApp .writeContent .card div span:last-child{
    font-size:13px;
    color:#555;
  }
  .eDetailApp .writeContent .con{
    padding-top:15px;
  }
  .eDetailApp .writeContent .con div{
    visibility: visible !important;
  }
  .eDetailApp .writeContent .con img{
    display:block;
    width:100% !important;
    margin:15px 0 ;
  }
  .eDetailApp .writeContent .con p,.eDetailApp .writeContent .con span{
    font-size:16px;
    color:#0d2148;
    line-height:22px;
    margin-bottom:10px;
    display:block;
    letter-spacing: 1px
  }

  .writeContent li:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0;
  }
  .writeContent ul h4{
    padding:20px 0;
    font-size:18px;
  }
  .writeContent li{
    border:1px #4c7ec0 dashed;
    border-radius:6px;
    background:#ecf2f8;
    padding:15px;
    position: relative;
    margin-bottom:15px;
  }
  .writeContent li.last span{
    display:block;
    text-align:center;
    font-size:15px;
    color:#333;
    padding-top:5px;
  }
  .writeContent li.last font{
    background:#007ae6;
    display:block;
    width:20px;
    height:20px;
    text-align:center;
    color:#fff;
    line-height:18px;
    border-radius:50%;
    margin:0 auto;
    font-weight:bold
  }
  .writeContent li .writePro{
    float:left;
    width:35%;
    border-radius:6px;
  }
  .writeContent li .cpName{
    float:left;
    width:62%;
    margin-left:3%
  }
  .writeContent li .cpName h3{
    font-size:16px;
  }
  .writeContent li .cpName .price{
    font-size:18px;
    font-weight:bold;
    color:#ea4d2e;
    padding-top:15px;
  }
  .writeContent li .cpName .price span{
    font-size:13px;
    color:#555;
    text-decoration:line-through;
    padding-left:5px;
  }
  .writeContent li .close{
    background:#ea4d2e;
    color:#fff;
    font-size:16px;
    position: absolute;
    width:30px;
    height:25px;
    right:0;
    top:0px;
    border-top-right-radius:6px;
    text-align:center;
  }

  .eDetailApp .shareFooter{
    height: 50px;
    background: #fff;
    width: 100%;
    box-shadow:0px 0px 20px 0px rgba(102,102,102,0.3);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9
  }
  .eDetailApp .shareFooter .edit{
    float:left;
    width:25%;
    text-align:center;
    margin: 0 5%;
    margin-top:5px;
  }
  .eDetailApp .shareFooter .edit span{
    font-size:15px;
    width:100%;
    height:40px;
    display:block;
    text-align:center;
    line-height:40px;
    background:#ddd;
    border-radius:6px;
  }
  .eDetailApp .shareFooter .shareTo{
    float:right;
    width:61%;
    height:40px;
    background:#007ae6;
    text-align:center;
    line-height:40px;
    color:#fff;
    font-size:15px;
    font-weight:bold;
    border-radius:6px;
    margin-top:5px;
    margin-right:2%
  }
  .iconT{
    float:right;
    font-size:22px;
    color:#666;
    margin-top:15px
  }

  .eDetailApp .writeContent .con img{
    border:dashed 1px #666 !important;
  }
  .eDetailApp .writeContent .con p,.eDetailApp .con li{
    border:dashed 1px #666 !important;
    padding:5px !important;
    position:relative !important;
  }
  .eDetailApp .con p:after,.eDetailApp .con li:after{
    position:absolute !important;
    width:100%!important;
    height:100% !important;
    background:rgba(0,0,0,.1) !important;
    left:0 !important;
    top:0 !important;
    content:'×';
    text-align:right;
    font-size:30px;
    color:red;

  }
</style>